import React, { useContext } from 'react'
import { Box, Button,  Text } from '@chakra-ui/react'
import DashboardLayout from '../../layouts/DashboardLayout'
import PreviewOrderSummary, { PreviewOrderSummarySkeletion } from '../../components/orders/PreviewOrderSummary'
import { useQuery } from 'react-query'
import { getOrder } from '../../services/orders'
import { AdminContext } from '../../contexts/AdminContext'
import { useParams } from 'react-router-dom';

const OrderPreview = () => {
  const { admin } = useContext(AdminContext)
  const { id } = useParams();

  const token = `bearer ${admin.token}`
  const order = useQuery(['orders', id], () => getOrder(id, token))

  return (
    <React.Fragment>
      <DashboardLayout>
        <Box mt='20px'>
          {order.isLoading &&
            <PreviewOrderSummarySkeletion />
          }

          {order.data &&
            <PreviewOrderSummary
              order={order.data}
            />
          }

          {order.isError &&
            <Box textAlign='center'>
              <Text
                p='2' color='red.500'
                fontWeight='semibold'
              >
                Failed to fetch Order
              </Text>

              <Button colorScheme='green' size='lg' onClick={() => order.refetch()}>
                Try again
              </Button>
            </Box>
          }
        </Box>
      </DashboardLayout>
    </React.Fragment>
  )
}

export default OrderPreview